jQuery(document).ready(function($) {
$(window).scroll(function() {
	if ($(this).scrollTop() > 1){  
		$('.site').addClass("sticky");
	}
	else{
		$('.site').removeClass("sticky");
	}
});
});


// SLICK SLIDER
jQuery(document).ready(function($) {
  $('.hero-slider').slick({
	dots: false,
	nav: false,
	arrows: false,
	infinite: true,
	speed: 500,
	fade: true,
	cssEase: 'linear',
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 7000,
	useAutoplayToggleButton: false,
	pauseOnHover: false,
  });
});

// PAGE IMAGE SLIDER
jQuery(document).ready(function($) {
	$('.page-image-slider').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		$slider.slick({
			dots: true,
			adaptiveHeight: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: true,
		});
	});
});


// HOME CAPABILITIES SLIDER
jQuery(document).ready(function($) {
  
  $('.news-slider-wrap').each(function (index, sliderWrap) {
	var $slider = $(sliderWrap).find('.slider');
	var $next = $(sliderWrap).find('.next');
	var $prev = $(sliderWrap).find('.prev');
	$slider.slick({
	  dots: false,
	  slidesToShow: 3,
	  slidesToScroll: 1,
	  infinite: true,
	  nextArrow: $next,
	  prevArrow: $prev,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  useAutoplayToggleButton: false,
	  
	  responsive: [
	  {
		breakpoint: 1156,
		settings: {
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		}
	  },
	  {
		breakpoint: 768,
		settings: {
		slidesToShow: 2,
		adaptiveHeight: true,
		slidesToScroll: 1
		}
	  },
	  {
		breakpoint: 600,
		settings: {
		slidesToShow: 1,
		adaptiveHeight: true,
		slidesToScroll: 1
		}
	  }
	  // You can unslick at a given breakpoint now by adding:
	  // settings: "unslick"
	  // instead of a settings object
	  ]
	});
  });
});


jQuery(document).ready(function($) {
/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */
function myFunction() {
  document.getElementById("myDropdown").classList.toggle("show");
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches('.dropbtn')) {
	var dropdowns = document.getElementsByClassName("dropdown-content");
	var i;
	for (i = 0; i < dropdowns.length; i++) {
	  var openDropdown = dropdowns[i];
	  if (openDropdown.classList.contains('show')) {
		openDropdown.classList.remove('show');
	  }
	}
  }
}

});